/* Fumer Supply Co - motion layer */
(function(){
  document.documentElement.classList.add('fs-motion-ready');
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* scroll reveal */
  function reveal(){
    var els = document.querySelectorAll('.fs-rv');
    if(mq || !('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold:0.12, rootMargin:'0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  /* seamless marquee: duplicate track content once */
  function marquee(){
    document.querySelectorAll('.fs-marq__t').forEach(function(t){
      if(t.dataset.dup) return; t.dataset.dup='1';
      t.innerHTML = t.innerHTML + t.innerHTML;
    });
  }

  /* parallax */
  function parallax(){
    if(mq) return;
    var items = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if(!items.length) return;
    var ticking=false;
    function upd(){
      var vh = window.innerHeight;
      items.forEach(function(el){
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.dataset.parallax)||0.12;
        var off = (r.top + r.height/2 - vh/2) * -speed;
        el.style.transform = 'translate3d(0,'+off.toFixed(1)+'px,0)';
      });
      ticking=false;
    }
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(upd); ticking=true; } }, {passive:true});
    upd();
  }

  /* stat counters */
  function counters(){
    var els = document.querySelectorAll('[data-count]');
    if(!els.length) return;
    if(mq || !('IntersectionObserver' in window)){ els.forEach(function(e){ e.textContent = (e.dataset.prefix||'') + e.dataset.count + (e.dataset.suffix||''); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return; io.unobserve(en.target);
        var el = en.target, target = parseFloat(el.dataset.count), pre = el.dataset.prefix||'', suf = el.dataset.suffix||'', t0=null, dur=1400;
        function step(ts){ if(!t0) t0=ts; var p=Math.min((ts-t0)/dur,1); var e=1-Math.pow(1-p,3); el.textContent = pre + Math.round(target*e).toLocaleString() + suf; if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }, { threshold:0.5 });
    els.forEach(function(e){ io.observe(e); });
  }

  function init(){ marquee(); reveal(); parallax(); counters(); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
